import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess102003Status: 'idle',
    startProcess102003Error: undefined as any,
    loadUserParamsProcess102003Status: 'idle',
    loadUserParamsProcess102003Error: undefined as any,

    process102003List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess102003 = createAsyncThunk('process102003Slice/startProcess102003', async ({ process102003 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess102003/`,
        prepareData(process102003),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess102003Status } = getState().process102003Slice
        return startProcess102003Status !== 'pending'
    }
})

export const loadUserParamsProcess102003 = createAsyncThunk('process102003Slice/loadUserParamsProcess102003', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess102003/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess102003Status } = getState().process102003Slice
        return loadUserParamsProcess102003Status !== 'pending'
    }
})

const Process102003Slice = createSlice({
    name: 'process102003Slice',
    initialState,
    reducers: {
        resetstartProcess102003: (state) => {
            state.job = undefined
            state.startProcess102003Error = undefined
        },
        resetstartProcess102003Error: (state) => {
            state.startProcess102003Error = undefined
        },
        resetloadUserParamsProcess102003: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess102003Error = undefined
        },
        resetloadUserParamsProcess102003Error: (state) => {
            state.loadUserParamsProcess102003Error = undefined
        },
        removeFromProcess102003ListById: (state, action) => {
            state.process102003List = state.process102003List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess102003ListByIds: (state, action) => {
            state.process102003List = state.process102003List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process102003List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess102003Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process102003List = []
            state.startProcess102003Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess102003.pending, (state) => {
            state.startProcess102003Status = 'pending'
            state.startProcess102003Error = undefined
        })
        builder.addCase(startProcess102003.fulfilled, (state, action) => {
            state.startProcess102003Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess102003.rejected, (state, action) => {
            state.startProcess102003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess102003Error = action.error.message
            } else {
                state.startProcess102003Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess102003.pending, (state) => {
            state.loadUserParamsProcess102003Status = 'pending'
            state.loadUserParamsProcess102003Error = undefined
        })
        builder.addCase(loadUserParamsProcess102003.fulfilled, (state, action) => {
            state.loadUserParamsProcess102003Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess102003.rejected, (state, action) => {
            state.loadUserParamsProcess102003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess102003Error = action.error.message
            } else {
                state.loadUserParamsProcess102003Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess102003,
    resetstartProcess102003Error,
    resetloadUserParamsProcess102003,
    resetloadUserParamsProcess102003Error,
    removeFromProcess102003ListById,
    removeFromProcess102003ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process102003Slice.actions
export default Process102003Slice.reducer
